module.exports = __webpack_public_path__ + "img/男鞋3.e15e984e.png";